export function getStringTrimmed(_ref) {
  var input = _ref.input,
    _ref$trim = _ref.trim,
    trim = _ref$trim === void 0 ? "trimboth" : _ref$trim;
  var inputSplittedByLines = input.split("\n");
  inputSplittedByLines = inputSplittedByLines.filter(function (inputLine) {
    return inputLine.length > 0;
  });
  inputSplittedByLines = inputSplittedByLines.map(function (inputLine) {
    if (trim === "trimboth") {
      inputLine = inputLine.trim();
    }
    if (trim === "trimleft") {
      inputLine = inputLine.trimStart();
    }
    if (trim === "trimright") {
      inputLine = inputLine.trimEnd();
    }
    return inputLine;
  });
  return inputSplittedByLines.join("\n");
}